import React, { useEffect, useCallback, useState } from "react";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import MachinesList from "../../components/maintenance/MachinesList";
import { STARTING_PAGE } from "../../constants/constants";
import {
  fetchMachines,
  fetchMachinesSuccess,
  fetchMachinesFailure,
  fetchMachineTypes,
  fetchMachineTypesSuccess,
  fetchMachineTypesFailure,
  fetchMaintenanceLocations,
  fetchMaintenanceLocationsSuccess,
  fetchMaintenanceLocationsFailure,
  deleteMachine,
  deleteMachineSuccess,
  deleteMachineFailure,
} from "../../store/maintenance/actions";

const MachinesListContainer = ({
  machines,
  machineTypes,
  locations,
  fetchMachines,
  fetchMachineTypes,
  fetchMaintenanceLocations,
  deleteMachine,
}) => {
  const [currentPage, setCurrentPage] = useState(STARTING_PAGE);
  const [filters, setFilters] = useState({
    machineType: null,
    location: null,
    status: null,
    search: null,
  });

  useEffect(() => {
    fetchMachines(STARTING_PAGE);
    fetchMachineTypes();
    fetchMaintenanceLocations();
  }, [fetchMachines, fetchMachineTypes, fetchMaintenanceLocations]);

  const handleFilter = useCallback(
    (newFilters) => {
      setFilters(newFilters);
      setCurrentPage(STARTING_PAGE);
      fetchMachines(
        STARTING_PAGE,
        newFilters.machineType || null,
        newFilters.location || null,
        newFilters.status || null,
        newFilters.search || null
      );
    },
    [fetchMachines]
  );

  const handlePageRequest = useCallback(
    (data) => {
      const page = data.selected + 1;
      if (page !== currentPage) {
        setCurrentPage(page);
        fetchMachines(
          page,
          filters.machineType || null,
          filters.location || null,
          filters.status || null,
          filters.search || null
        );
      }
    },
    [currentPage, filters, fetchMachines]
  );

  const handleDelete = useCallback(
    (id) => {
      if (window.confirm("Are you sure you want to delete this machine?")) {
        deleteMachine(id);
      }
    },
    [deleteMachine]
  );

  return (
    <>
      <MachinesList
        machines={machines.list}
        machineTypes={machineTypes.list}
        locations={locations.list}
        loading={machines.loading}
        error={machines.error}
        onFilter={handleFilter}
        onDelete={handleDelete}
      />
      {machines.pages > 1 && (
        <ReactPaginate
          pageCount={machines.pages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          previousLabel="<"
          nextLabel=">"
          onPageChange={handlePageRequest}
          initialPage={currentPage - 1}
          disableInitialCallback={true}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="page-item active"
          previousClassName="paginate_button previous"
          nextClassName="paginate_button next"
          disabledClassName="page-item disabled"
          forcePage={currentPage - 1}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  machines: state.maintenance.machines,
  machineTypes: state.maintenance.machineTypes,
  locations: state.maintenance.locations,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMachines: (page, machineType, location, status, search) => {
    dispatch(fetchMachines(page, machineType, location, status, search)).payload.then(
      (response) => {
        console.log("fetchMachines response.data:", response.data);
        dispatch(fetchMachinesSuccess(response.data));
      },
      (error) => {
        console.error("fetchMachines error:", error);
        dispatch(fetchMachinesFailure(error.response?.data || error));
      }
    );
  },
  fetchMachineTypes: () => {
    dispatch(fetchMachineTypes(1, null, null, 9999)).payload.then(
      (response) => {
        dispatch(fetchMachineTypesSuccess(response.data));
      },
      (error) => {
        dispatch(fetchMachineTypesFailure(error.response?.data || error));
      }
    );
  },
  fetchMaintenanceLocations: () => {
    dispatch(fetchMaintenanceLocations(1, null, null, 9999)).payload.then(
      (response) => {
        dispatch(fetchMaintenanceLocationsSuccess(response.data));
      },
      (error) => {
        dispatch(fetchMaintenanceLocationsFailure(error.response?.data || error));
      }
    );
  },
  deleteMachine: (id) => {
    dispatch(deleteMachine(id)).payload.then(
      () => {
        dispatch(deleteMachineSuccess(id));
      },
      (error) => {
        dispatch(deleteMachineFailure(error.response?.data || error));
      }
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MachinesListContainer);
